import { MutationTree } from 'vuex';
import { set } from 'lodash';

export const state = () => ({
  id: null,
  query: {
    where: {},
    sort: 'createdAt',
    offset: 0,
    limit: 10,
    include: ['rpx-dna-category', 'rpx-dna-sub-category-translation']
  },
  table: {
    footer: {
      'items-per-page-options': [10, 25, 50, 100],
      'show-current-page': true,
      'show-first-last-page': true
    },
    filter: {
      id: [],
      dnaPanelId: [],
      dnaCategoryId: [],
      keyword: ''
    },
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['createdAt'],
      sortDesc: [false],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: true
    }
  }
});

export type SKUSubCategoryState = ReturnType<typeof state>;

export const mutations: MutationTree<SKUSubCategoryState> = {
  changeId: (state, id) => (state.id = id),
  changeQuery: (state, query) => Object.assign(state.query, query),
  changeTableFilter: (state, filter) => {
    Object.assign(state.table, { filter });
    Object.assign(state.query, {
      where: {
        id: filter.id,
        keyword: filter.keyword,
        dnaPanelId: filter.dnaPanelId,
        dnaCategoryId: filter.dnaCategoryId
      }
    });
  },
  changeTableOptions: (state, options) => {
    Object.assign(state.table, { options });
    Object.assign(state.query, {
      sortObject: set(
        {},
        options.sortBy[0],
        options.sortDesc[0] ? 'DESC' : 'ASC'
      ),
      limit: options.itemsPerPage,
      offset: (options.page - 1) * options.itemsPerPage
    });
  }
};
